import { Link } from "react-router";

import type { StalledRenewalResource } from "@/lib/api-types";
import { formatDateCell } from "@/lib/format";

/**
 * "Renewal pipeline"'s own stalled-conversation list (Story 13.2, R-H3) —
 * mirrors `NextThirtyDaysRow.tsx`/`RecentActivityRow.tsx`'s identical
 * shape: a sentence at `{typography.body}`, the status plus follow-up
 * state at `{typography.meta}` beneath, the whole row the one working link
 * (AD-27) to its own renewal record.
 */
export interface StalledRenewalRowProps {
  item: StalledRenewalResource;
}

export function StalledRenewalRow({ item }: StalledRenewalRowProps) {
  const followUp = item.next_follow_up_date
    ? `Follow-up was due ${formatDateCell(item.next_follow_up_date)}`
    : "No follow-up scheduled";
  const meta = `${item.status_label} · ${followUp}`;

  const content = (
    <>
      <p className="text-body text-ink">{item.entity_label ?? "Renewal"}</p>
      <p className="mt-1 text-meta text-ink-secondary">{meta}</p>
    </>
  );

  return (
    <li className="min-h-alert-row border-b border-border-hairline bg-surface">
      {item.entity_url ? (
        <Link
          to={item.entity_url}
          className="block min-h-alert-row px-2 py-3 text-ink no-underline hover:underline"
        >
          {content}
        </Link>
      ) : (
        <div className="min-h-alert-row px-2 py-3">{content}</div>
      )}
    </li>
  );
}
